<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav" />
    <div class="record-depot">
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name"> <i class="record"></i>唱片总览 </span>
          </div>
          <div class="list-tap">
            <span
              :class="listType === 1 ? 'cur' : ''"
              @click="listTypeChange(1)"
            ></span>
            <span
              :class="listType === 2 ? 'cur' : ''"
              @click="listTypeChange(2)"
            ></span>
          </div>
        </div>
        <div v-if="listType === 1">
          <div class="depot-filter-box">
            <div
              class="depot-filter"
              v-if="subjectDict && subjectDict.length > 0"
            >
              <span class="lb">主题分类</span>
              <div class="fs">
                <span
                  :class="subjectCurrent === -1 ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'subject')"
                  >全部</span
                >
                <template v-for="(item, index) in subjectDict">
                  <span
                    v-if="showAllSpan[0] ? true : index < 15"
                    :key="'subjectDict' + index"
                    :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                    @click="handleFilter(item, index, 'subject')"
                  >
                    {{ item.facet }} <i>{{ item.count }}</i>
                  </span>
                </template>
                <span
                  v-if="subjectDict.length > 15"
                  :class="showAllSpan[0] ? 'all' : 'all cur'"
                  @click="changeShowAllSpan(0)"
                  >{{ showAllSpan[0] ? "收起" : "全部" }} <i></i
                ></span>
              </div>
            </div>
            <div class="depot-filter" v-if="plDict && plDict.length > 0">
              <span class="lb">出版地点</span>
              <div class="fs">
                <span
                  :class="plCurrent === -1 ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'pl')"
                  >全部</span
                >
                <template v-for="(item, index) in plDict">
                  <span
                    v-if="showAllSpan[1] ? true : index < 15"
                    :key="'plDict' + index"
                  :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                    @click="handleFilter(item, index, 'pl')"
                  >
                    {{ item.facet }} <i>{{ item.count }}</i>
                  </span>
                </template>
                <span
                  v-if="plDict.length > 15"
                  :class="showAllSpan[1] ? 'all' : 'all cur'"
                  @click="changeShowAllSpan(1)"
                  >{{ showAllSpan[1] ? "收起" : "全部" }} <i></i
                ></span>
              </div>
            </div>
            <div class="depot-filter" v-if="langDict && langDict.length > 0">
              <span class="lb"
                >语&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种</span
              >
              <div class="fs">
                <span
                  :class="langCurrent === -1 ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'lang')"
                  >全部</span
                >
                <template v-for="(item, index) in langDict">
                  <span
                    v-if="showAllSpan[2] ? true : index < 15"
                    :key="'langDict' + index"
                  :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                    @click="handleFilter(item, index, 'lang')"
                  >
                    {{ item.facet }} <i>{{ item.count }}</i>
                  </span>
                </template>
                <span
                  v-if="langDict.length > 15"
                  :class="showAllSpan[2] ? 'all' : 'all cur'"
                  @click="changeShowAllSpan(2)"
                  >{{ showAllSpan[2] ? "收起" : "全部" }} <i></i
                ></span>
              </div>
            </div>
            <div class="depot-slide">
              <div class="slide-box">
                <span class="lb">出版时间</span>
                <div class="slide">
                  <a-slider
                    range
                    :min="1910"
                    :max="2015"
                    :default-value="[1910, 2015]"
                    @afterChange="onSliderChange"
                  />
                </div>
                <div style="margin-left: 2%; color: #999">
                  {{ sliderCurrVal[0] }}~{{ sliderCurrVal[1] }}
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="result-count">
              <span
                >共<b>{{ rowCount }}</b
                >种</span
              >
              <div
                :class="
                  showMobileFilter ? 'mb-filter-btn cur' : 'mb-filter-btn'
                "
                @click.stop="showMobileFilter = !showMobileFilter"
              >
                筛选
              </div>
              <div class="list-tap">
                <span
                  :class="listType === 1 ? 'cur' : ''"
                  @click="listType = 1"
                ></span>
                <span
                  :class="listType === 2 ? 'cur' : ''"
                  @click="listType = 2"
                ></span>
              </div>
              <div class="sort">
                <span :class="sort.field === 'TI' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TI')"
                  >题名</span
                >
                <span :class="sort.field === 'TIME' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TIME')"
                  >出版时间</span
                >
                <span :class="sort.field === 'CO' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('CO')"
                  >责任者</span
                >
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放唱片</span
                >
              </div>
            </div>
            <div class="filter-keys" v-if="filterKeys.length > 0">
              <div class="lb">已选项：</div>
              <div
                v-for="(f, index) in filterKeys"
                :key="index + f.text"
                class="f-k"
              >
                {{ f.text }} <i class="cls" @click="deleteFilter(index)"></i>
              </div>
            </div>
            <div class="record-list">
              <div
                v-for="(item, index) in recordList"
                :key="'recordList' + index"
                class="record-cell"
              >
                <div class="pic" >
                    <router-link :to="'/rec-info/'+encodeURIComponent(item['@id'])" v-if="item.title"> 
                  <img
                    v-if="item.cover[0]"
                    :src="
                      'https://img.library.sh.cn/hisdata/cp/img/' +
                      item.cover[0]
                    "
                    alt=""
                  />
                  <img v-else :src="baseRecordPic" alt="" />
                  </router-link>
                    <div v-if="item.playable" class="h-box" @click="playSong(item, index)">
                    </div>
                </div>
                <router-link
                  :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                  class="tit"
                  v-if="item.dcTitle"
                  :title="item.dcTitle['@value'].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'')"
                >
                  {{ item.dcTitle["@value"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}
                </router-link>
                <div
                  class="info"
                  v-if="item.classification && item.classification.prefLabel"
                >
                  {{ item.classification.prefLabel["@value"] }}
                </div>
                <div class="info" v-if="!isMobile && item.language">
                  {{ item.language["@value"] }}
                </div>
                <!-- <div class="info" v-if="item.subject">{{Array.isArray(item.subject) ? item.subject.join('\xa0\xa0\xa0') : item.subject}}</div> -->
                <!-- <div class="info">{{item.type}}</div>
              <div class="info">{{item.date}}</div> -->
              </div>
              <div class="clear-f"></div>
            </div>
            <a-spin class="page-load" v-if="pageLoad" />
            <!-- <div
              class="load-more"
              @click="onLoadMore(5)"
              v-if="
                searchParams.pager &&
                searchParams.pager.pageSize &&
                searchParams.pager.pageSize < rowCount
              "
            >
              <i></i>点击加载更多...
            </div> -->
          </div>
        </div>
        <div v-else class="depot-list-box">
          <div class="left-filter">
            <div class="ft-box" v-if="subjectDict && subjectDict.length > 0">
              <div class="tit">
                <i></i>主题分类
                <span
                  :class="showAll[0] ? 'cur' : ''"
                  @click="showAllHandle(0)"
                ></span>
              </div>
              <div :class="showAll[0] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === subjectCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'subject')"
                >
                  <span>全部</span>
                  <!-- <span>{{ subjectCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in subjectDict"
                  :key="'subjectDict' + index"
                  :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'subject')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
            <div class="ft-box" v-if="plDict && plDict.length > 0">
              <div class="tit">
                <i></i>出版地点
                <span
                  :class="showAll[1] ? 'cur' : ''"
                  @click="showAllHandle(1)"
                ></span>
              </div>
              <div :class="showAll[1] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === plCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'pl')"
                >
                  <span>全部</span>
                  <!-- <span>{{ plCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in plDict"
                  :key="'plDict' + index"
                :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'pl')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
            <div class="ft-box" v-if="langDict && langDict.length > 0">
              <div class="tit">
                <i></i>语种
                <span
                  :class="showAll[2] ? 'cur' : ''"
                  @click="showAllHandle(2)"
                ></span>
              </div>
              <div :class="showAll[2] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === langCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'lang')"
                >
                  <span>全部</span>
                  <!-- <span>{{ langCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in langDict"
                  :key="'langDict' + index"
                    :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'lang')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="depot-slide">
              <div class="slide-box">
                <span class="lb">出版时间</span>
                <div class="slide">
                  <a-slider
                    range
                    :min="1910"
                    :max="2015"
                    :default-value="[1910, 2015]"
                    @afterChange="onSliderChange"
                  />
                </div>
                <div style="margin-left: 2%; color: #999">
                  {{ sliderCurrVal[0] }}~{{ sliderCurrVal[1] }}
                </div>
              </div>
            </div> -->
          </div>
          <div class="right-content">
            <div class="result-count">
              <span
                >共<b>{{ rowCount }}</b
                >种</span
              >
              <div
                :class="
                  showMobileFilter ? 'mb-filter-btn cur' : 'mb-filter-btn'
                "
                @click.stop="showMobileFilter = !showMobileFilter"
              >
                筛选
              </div>
              <div class="list-tap">
                <span
                  :class="listType === 1 ? 'cur' : ''"
                  @click="listType = 1"
                ></span>
                <span
                  :class="listType === 2 ? 'cur' : ''"
                  @click="listType = 2"
                ></span>
              </div>
              <div class="sort">
                <span :class="sort.field === 'TI' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TI')"
                  >题名</span
                >
                <span :class="sort.field === 'TIME' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TIME')"
                  >出版时间</span
                >
                <span :class="sort.field === 'CO' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('CO')"
                  >责任者</span
                >
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放唱片</span
                >
              </div>
            </div>
            <div class="filter-keys" v-if="filterKeys.length > 0">
              <div class="lb">已选项：</div>
              <div
                v-for="(f, index) in filterKeys"
                :key="index + f.text"
                class="f-k"
              >
                {{ f.text }} <i class="cls" @click="deleteFilter(index)"></i>
              </div>
            </div>
            <div class="result-list">
              <div
                v-for="(item, index) in recordList"
                :key="index"
                class="result-cell"
              >
                <div class="index">{{ index + 1 }}</div>
                <div class="pic">
                  <router-link
                    :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                  >
                    <img
                      v-if="item.cover[0]"
                      :src="
                        'https://img.library.sh.cn/hisdata/cp/img/' +
                        item.cover[0]
                      "
                      alt=""
                    />
                    <img v-else :src="baseRecordPic" alt="" />
                  </router-link>
                </div>
                <div class="info">
                   <router-link
                      :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                    >
                  <div
                    class="name"
                    v-if="item.dcTitle"
                    :title="item.dcTitle['@value'].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'')"
                  >
                   
                   {{ item.dcTitle["@value"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}
                   
                  </div>
                  <div class="des" v-if="item.creator">
                    <!-- <span>何占豪</span>独奏
                    <span>何占豪</span>词
                    <span>何占豪</span>曲 -->
                    <span
                      :title="
                        Array.isArray(item.creator)
                          ? item.creator.join('\xa0\xa0\xa0')
                          : item.creator
                      "
                    >
                      {{
                        Array.isArray(item.creator)
                          ? item.creator.join("\xa0\xa0\xa0")
                          : item.creator
                      }}
                    </span>
                  </div>
                  <!-- <div class="des" v-if="item.provisionActivity && item.provisionActivity.date">
                    <span>{{item.provisionActivity.date}}年</span>出版
                  </div> -->
                  <div class="des" v-if="item.language">
                    语种：  <span>{{ item.language["@value"] }}</span>
                  </div>
                  <div class="des" v-if="item.genre">
                    <span>{{ item.genre }}</span>
                  </div>
                   </router-link>
                </div>
                <div class="act">
                  <!-- <span v-if="item.playable" :class="playIndex == index ? 'play curPlay' : 'play'" @click="playSong(item,index)"></span> -->
                  <span v-if="!item.playable" class="noplay"></span>
                 <span v-if="item.playable" :class="playIndex == index ? 'play curPlay' : 'play'" @click="playSong(item,index)"></span>
                 
                  <span
                    :class="item.isFavorite ? 'fav cur' : 'fav'"
                    @click="handleFav(index)"
                  ></span>
                  <ShareIcon
                    :shareConfig="{
                      url: '/rec-info/' + encodeURIComponent(item['@id']),
                      title: item.dcTitle['@value'],
                    }"
                  ></ShareIcon>
                </div>
              </div>
            </div>
            <div class="page-box">
              <a-pagination
                :total="pagerCount"
                :current="currentPage"
                @change="onChange"
                show-quick-jumper
                show-less-items
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Player ref="player" @curPlay="curPlay" />
    <div
      :class="showMobileFilter ? 'mobile-filter-tk cur' : 'mobile-filter-tk'"
    >
      <div class="depot-filter" v-if="subjectDict && subjectDict.length > 0">
        <span class="lb">主题分类</span>
        <div class="scroll-box">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
               <div class="fs" :style="'width:' + (subjectDict.length)*1.15 + 'rem'">
            <span
              :class="subjectCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1, -1, 'subject')"
              >全部</span
            >
            <span
              v-for="(item, index) in subjectDict"
              :key="'subjectDict' + index"
                :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item, index, 'subject')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter" v-if="plDict && plDict.length > 0">
        <span class="lb">出版地点</span>
        <div class="scroll-box">
           <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
              <div class="fs" :style="'width:' + (plDict.length+1)*0.8 + 'rem'">
            <span
              :class="plCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1, -1, 'pl')"
              >全部</span
            >
            <span
              v-for="(item, index) in plDict"
              :key="'plDict' + index"
                 :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item, index, 'pl')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter" v-if="langDict && langDict.length > 0">
        <span class="lb">语种</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + (langDict.length+1) + 'rem'">
              <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="langCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1, -1, 'lang')"
              >全部</span
            >
            <span
              v-for="(item, index) in langDict"
             :key="'langDict' + index"
                  :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item, index, 'lang')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>

      <div class="depot-slide">
        <div class="slide-box">
          <span class="lb">出版时间</span>
          <div class="slide">
            <a-slider
              range
              :min="1910"
              :max="2015"
              :default-value="[1910, 2015]"
              @afterChange="onSliderChange"
            />
          </div>
          <div style="margin-left: 2%; color: #999">
            {{ sliderCurrVal[0] }}~{{ sliderCurrVal[1] }}
          </div>
        </div>
      </div>
         <div class="depot-filter">
          <div class="sort">
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放唱片</span
                >
              </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import { baseRecordPic } from "@/util/basePic";
import { phonorecordSearch, collFav, ncollFav } from "@/api";
import ShareIcon from "@/components/shareIcon";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
export default {
  components: {
    Nav,
    Footer,
    Player,
    ShareIcon,
  },
  data() {
    return {
      isScroll: true,
      loginHref: null,
      isMobile,
      playIndex: -1,
      curIndex: -1,
      sc: false,
      pageLoad: true,
      sliderCurrVal: [1910, 2015], //日期检索条件值
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      dateParams: {}, // 出版时间检索参数
      dateCdtn: [], //日期高级检索条件
      hasAudio: false,
      onlyShowPlay: false,
      baseRecordPic,
      listType: 1,
      subjectCount: 0,
      visible: false,
      subjectCurrent: -1,
      subjectDict: [],
      plCount: 0,
      plCurrent: -1,
      plDict: [],
      showMobileFilter: false,
      noplay: false,
      langCount: 0,
      langCurrent: -1,
      langDict: [],
      facesTitleKey: [
        { key: "subject", title: "主题分类" },
        { key: "pl", title: "出版地" },
        { key: "lang", title: "语种" },
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      totalPage: 10, // 每页总数
      recordList: [],
      showAll: [true, true, true],
      showAllSpan: [false, false, false],
      filterKeys: [],
      sort: {
        field: "TI",
        order: "asc"
      }
    };
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer();
    next();
  },
  mounted() {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
    this.$nextTick(() => {
      document.body.addEventListener("click", () => {
        this.showMobileFilter = false;
      });
      this.searchParams = this.commonParamsHandling();
      if(this.GLOBAL.BASE_IP_INFO.ipIsInner){//如果是内网，直接勾选可播放按钮 chenss 20220831
        this.onlyShowPlay = true;
        this.hasAudio = this.onlyShowPlay;
      }
      this.query();
      //listType==1,才开启下拉刷新模式
      if (this.listType == 1) {
        this.pageScroll();
      }
    });
  },
  beforeDestroy() {
    document.body.removeEventListener("click", () => {
      this.showMobileFilter = false;
    });
  },
  methods: {
    //日期检索 条件设置
    onSliderChange(value) {
      this.sliderCurrVal = value;
      this.dateCdtn = [];
      this.dateParams.logic = "and";
      this.dateParams.field = "IS";
      this.dateParams.value = this.sliderCurrVal[0];
      this.dateParams.type = "2"; //大于起始日期
      this.dateCdtn.push(this.dateParams);
      this.dateParams = {};
      this.dateParams.logic = "and";
      this.dateParams.field = "IS";
      this.dateParams.value = this.sliderCurrVal[1];
      this.dateParams.type = "3"; //小于结束日期
      this.dateCdtn.push(this.dateParams);
      this.query(true); //查询数据， 并且刷新分面数据
    },
    onParamsHandle() {
      // 检索参数设置
      this.searchParams = this.commonParamsHandling();
      if (this.hasAudio) {
        // this.searchParams.facet = { hasAudio: this.hasAudio + "" };
        this.searchParams.resouce = { PLAY: "1" };
      }
      if (this.dateCdtn != null) {
        //日期检索条件
        this.searchParams.searchType = 2; //切换为高级检索
        this.searchParams.cdtn = this.dateCdtn;
      }
      // 排序
      const { field, order } = this.sort;
      this.searchParams.sorts = {
        [field]: order === "asc" ? 1 : 0
      };
      // 页码翻页
      //console.log(this.currentPage);
      this.searchParams.pager.pageth = this.currentPage;
      this.searchParams.pager.pageSize = this.totalPage;
      if (this.currentPage == 1) {
        this.recordList = [];
      }
      if (this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item, index) => {
        const dict = item.dict;
        // 简单检索
        if (dict == "keyword") {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if (dict.indexOf("Dict") != -1) {
          this.searchParams.facet[dict.replace("Dict", "").toUpperCase()] =
            item.text;
        }
      });
    },
    async query(facetsFlag = true) {
      this.pageLoad = true;
      // 参数设置
      this.onParamsHandle();
      const res = await phonorecordSearch(this.searchParams);
      if (res) {
        this.pageLoad = false;
      }
      const result = res.data;
      //如果是下拉加载模式，则需要追加数据，如果不是，则是直接替换
      if (this.isScroll == true) {
        this.recordList = this.recordList.concat(result.datas);
      } else {
        this.recordList = result.datas;
      }

      if (facetsFlag) {
        // 主题分类
        this.subjectDict =
          result.facets && result.facets.subjectFacet
            ? result.facets.subjectFacet
            : [];
        // 出版地
        this.plDict =
          result.facets && result.facets.plFacet ? result.facets.plFacet : [];
        // 语种
        this.langDict =
          result.facets && result.facets.langFacet
            ? result.facets.langFacet
            : [];
      }
      // 统计数量
      this.facesTitleKey.forEach((item, index) => {
        this.countHnadle(item.key);
      });
      // 总数
      this.rowCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 0;
      // 页码
      this.pagerCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    countHnadle(key) {
      // 统计数量
      this[key + "Count"] = 0;
      this[key + "Dict"].forEach((item, index) => {
        this[key + "Count"] += item.count;
      });
    },
    curPlay() {
      //console.log(123);
      this.playIndex = this.curIndex;
    },
    async playSong(item, index) {
      this.curIndex = index;
      this.$refs.player.playSong(this.$refs.Nav, item);
    },
    handleSortChange(field) {
      if (field === this.sort.field) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.field = field;
        this.sort.order = "asc";
      }
      this.currentPage = 1;
      this.query(false);
    },
    showAllHandle(a) {
      this.showAll.splice(a, 1, !this.showAll[a]);
      let count = 0;
      this.showAll.forEach((item) => {
        if (item) {
          count++;
        }
      });
      if (count > 3) {
        let flag = false;
        this.showAll.forEach((item, index) => {
          if (item && index !== a && !flag) {
            flag = true;
            this.showAll.splice(index, 1, false);
          }
        });
      }
    },
    async handleFav(index) {
      //点击收藏如果没有登录,则提示用户登录后方可操作
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.recordList[index].isFavorite
        ? await ncollFav({ uri: this.recordList[index]["@id"] })
        : await collFav({ uri: this.recordList[index]["@id"] });
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      this.$refs.Nav.cpnclick(this.recordList[index].isFavorite);
    },
    deleteFilter(index) {
      let key = this.filterKeys[index].dict.substring(0,this.filterKeys[index].dict.search("Dict"));
      this[key + "Current" ] = -1;
      //  alert('deleteFilter'+key);
      this.filterKeys.splice(index, 1);
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    changeShowAllSpan(index) {
      this.showAllSpan.splice(index, 1, !this.showAllSpan[index]);
    },
    getFacetText(key) {
     const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key ;
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      if(this.filterKeys[_i]){  return this.filterKeys[_i].text;}
      return '';
    },
    handleFilter(item, index, key) {
      
      this[key + "Current"] = item.facet ? item.facet : item;//被选中的分面值
      const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key + "Dict";
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      let facValue = this[key + "Dict"][index] && this[key + "Dict"][index].facet ? this[key + "Dict"][index].facet :'';//真正选中的分面值
      if (_i !== -1) {
          //如果是专题，则可以多选
          if(this.filterKeys[_i]){
            let tempList =this.filterKeys[_i].text.split(',');
              if(tempList.indexOf(facValue)==-1){//如果已转中数组中不存在当前值，则继续存入
                  if(facValue !=null && facValue!=''){
                  tempList.push(facValue);//被选中的主题分类数据
                  this.filterKeys[_i].text=tempList.join(',');
                  }
                  }
               else if(tempList.length>1) {//如果剩下的不是最后一个时候，允许移除
                tempList.splice(tempList.indexOf(facValue),1);//如果存在，则删除该值，重新查询
              }
              facValue =tempList.join(',');
           }
          if (index === -1) {
            this.filterKeys.splice(_i, 1);
            console.log('index === -1')
          } else {
            this.filterKeys.splice(_i, 1, {dict: key + "Dict", text: facValue});
          }
      } else if(facValue !=null && facValue!=''){//选中的分面值，如果不为空 做新增
           this.filterKeys.push({dict: key + "Dict", text: facValue});
      }
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    onLoadMore(n) {
      this.totalPage += n;
      this.query(false);
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.query(false);
      this.isScroll = false;
    },
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      this.currentPage = 1;
      this.query();
    },
    //页面滚动
    pageScroll() {
      let that = this;
      window.onscroll = function () {
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop + windowHeight > scrollHeight - 100) {
          if($('.record-cell').length != that.rowCount){//如果画面已经加载完成的的元素数量，不等于数据总条数，则继续进行查询
             that.currentPage++;
               that.query();
          }
          else if ($('.record-cell').length == that.rowCount){
           // alert(scrollTop + windowHeight+'---------'+scrollHeight)
           // alert('已经到底啦。。。');
          }
        }
      };
    },
    listTypeChange(index) {
      // 页面切换
      this.listType = index;
      this.currentPage = 1;
      this.totalPage = 10;
      this.query(false);
      if (index == 1) {
        this.isScroll = true;
        this.pageScroll();
      } else {
        this.isScroll = false;
        window.onscroll = function () {};
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-slider-handle {
  background: #ffffff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  border: none;
  margin-top: -5px;
  width: 20px;
  height: 20px;
  &:focus {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  }
}
/deep/.ant-slider-track {
  background: #eb5757 !important;
}
/deep/.ant-slider-rail,
/deep/.ant-slider-track {
  height: 10px;
}
/deep/.ant-slider {
  margin-top: 4px;
}
</style>
